module.exports = __webpack_public_path__ + "media/fonts/gravity-book-4fbe9fe336d30bbf433de62303e1895f.ttf";